import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import resize from '@/mixins/resize';
import * as echarts from 'echarts';
export default {
  name: 'annularPie',
  mixins: [resize],
  props: ['panelData'],
  data() {
    return {
      sourceX: ['保险1', '保险2', '保险3', '保险4'],
      source: [{
        name: '保险1',
        value: 85
      }, {
        name: '保险2',
        value: 75
      }, {
        name: '保险3',
        value: 65
      }, {
        name: '保险4',
        value: 55
      }],
      radiusList: [['75%', '82%'], ['63%', '70%'], ['51%', '58%'], ['39%', '46%'], ['27%', '34%'], ['14%', '22%'], ['2%', '10%']]
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initEchart();
    });
  },
  watch: {
    panelData: {
      handler() {
        this.$nextTick(() => {
          this.initEchart();
        });
      }
    },
    deep: true
  },
  methods: {
    initEchart() {
      if (this.panelData) {
        this.sourceX = this.panelData.sourceX;
        this.source = this.panelData.source;
      }
      let series = [];
      this.source.map((item, index) => {
        let obj = {
          name: item.name,
          type: 'pie',
          hoverAnimation: false,
          radius: this.radiusList[index] || [],
          center: ['50%', '53%'],
          itemStyle: {
            normal: {
              // color: '#4FD8FF',
              label: {
                show: true
              },
              labelLine: {
                show: false
              }
            }
          },
          data: [{
            value: item.value,
            name: item.name
          }, {
            value: 100 - item.value,
            name: '',
            itemStyle: {
              color: '#dedede'
            },
            hoverAnimation: false,
            tooltip: {
              show: false
            }
          }]
        };
        series.push(obj);
      });
      let that = this;
      this.myChart = echarts.init(this.$refs.annularPie);
      this.myChart.setOption({
        tooltip: {
          trigger: 'item'
        },
        legend: {
          show: true,
          left: '15',
          top: 0,
          type: 'scroll',
          itemWidth: 18,
          itemHeight: 11,
          data: that.sourceX,
          formatter: function (name) {
            return that.$t(name);
          }
        },
        series: series
      }, true);
    }
  }
};